module.exports = __webpack_public_path__ + "img/5-hsp.dc6869ed.jpg";